export const queryKeys = {
  APIS: 'apis',
  GROUPS: 'groups',
  USER_PROFILE: 'userProfile'
};

export const config = {
  STALE_TIME: 1000 * 60 * 60,
  CACHE_TIME: 1000 * 60 * 60
};
